export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.langtan': '',
  'menu.langtan.home': 'Dashboard',
  'menu.langtan.home.overview': 'Data Overview',
  'menu.langtan.home.analysis': 'Business Analysis',
  'menu.langtan.system': 'Project Config',
  'menu.langtan.system.department': 'Department Management',
  'menu.langtan.system.role': 'Role Management',
  'menu.langtan.system.staff': 'Staff Management',
  'menu.langtan.system.menu': 'Menu Management',
  'menu.langtan.system.permissionVersion': 'Version Management',
  'menu.langtan.poolSafety': 'Pool Safety',
  'menu.langtan.poolSafety.cameraList': 'Camera List',
  'menu.langtan.poolSafety.groupList': 'Group List',
  'menu.langtan.poolSafety.recognitionConfig': 'Recognition Config',
  'menu.langtan.poolSafety.recognitionActionConfig': 'Pool Action Switches',
  'menu.langtan.poolSafety.visionOpenCredential': 'Open API Credentials',
  'menu.langtan.projectSafety': 'Safety Config',
  'menu.langtan.projectSafety.visionOpenCredential': 'Open API Credentials',
  'menu.langtan.projectSafety.recognitionActionDict': 'Action Dictionary',
  'menu.langtan.poolSafety.visionHeadcountHistory': 'Lane Headcount Reports',
  'menu.langtan.poolSafety.visionModelHealthHistory': 'Model Health History',
  'menu.langtan.poolSafety.recognitionAlarmRecords': 'Action Report Records',
  'menu.langtan.poolSafety.visionMediaUploadHistory': 'Media Upload Records',
  'menu.langtan.poolSafety.visionStreamRegisterHistory': 'Stream Register Logs',
  'menu.langtan.poolSafety.monitorScreen': 'Screen View Config',
  'menu.langtan.poolSafety.alarmTemplate': 'Alarm Templates',
  'menu.langtan.poolSafety.alarmTest': 'Alarm Test',
  'menu.langtan.poolSafety.evidenceRecording': 'Evidence Recording',
  'menu.langtan.poolSafety.alarmHandling': 'Alarm Records',
  'menu.langtan.poolSafety.alarmMessageRecords': 'Message Records',
  'menu.langtan.poolSafety.staffWorkStats': 'Staff Work Stats',
  'menu.langtan.poolSafety.deviceMgmt': 'Device Management',
  'menu.langtan.poolSafety.terminalDeviceList': 'Device List',
  'menu.langtan.poolSafety.deviceMonitor': 'Device Monitor',
  'menu.langtan.poolSafety.systemLog': 'System Log',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
